import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { isStaffUser } from '../../../../../utils/user'
import { BuildingSelect } from '../../../../Building'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  REQUEST_FORM_FIELD_NAME_APPLICANT,
  REQUEST_FORM_FIELD_NAME_BUILDING,
  REQUEST_FORM_FIELD_NAME_FLAT,
} from '../../RequestForm.constants'

import { getBuildingApiParams } from './BuildingFields.utils'

function BuildingField({ apiParams, requiredFields, ...restProps }) {
  const { t } = useTranslation()

  const { setFieldValue, values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  function handleClear() {
    setFieldValue(REQUEST_FORM_FIELD_NAME_FLAT, null)
  }

  const buildingApiParams = {
    ...apiParams,
    ...getBuildingApiParams(
      values,
      isStaffUser(values[REQUEST_FORM_FIELD_NAME_APPLICANT] || EMPTY_OBJECT)
    ),
  }

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={BuildingSelect}
      apiParams={buildingApiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Request.BuildingPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('Request.BuildingLabelKey')}:`,
        required: requiredFields.includes(REQUEST_FORM_FIELD_NAME_BUILDING),
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_FORM_FIELD_NAME_BUILDING}
      onClear={handleClear}
    />
  )
}

export default BuildingField
